import { fromJS } from 'immutable'
import {
  LOB_GET_REQUEST,
  LOB_GET_SUCCESS,
  LOB_GET_FAILURE,
  LOB_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LOB_GET_REQUEST:
      return state
        .set('isFetching', true)
    case LOB_GET_SUCCESS:
      return state
        .set('lob', fromJS(action.payload.LOB))
        .set('isFetching', false)
    case LOB_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LOB_GET_RESET:
      return state
        .delete('lob')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lob/lob-get-reducer.js